<template>
  <layout-basic>
    <v-container fluid class="pr-2">
      <v-row>
        <v-col class="Full-Course-Library-Title pt-0">
          My Playlists
        </v-col>
      </v-row>
      <v-container v-if="loading" grid-list-md fluid class="pa-0 pt-5">
        <v-layout wrap>
          <v-flex v-for="index in 4" :key="index" xs11 sm6 lg3 class="mb-5">
            <v-card :class="[{ 'mr-6': isTabletOrDesktop }]" height="100%">
              <v-skeleton-loader elevation="2" class="card-loader" type="list-item-two-line, image, list-item, button">
              </v-skeleton-loader>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container grid-list-md fluid class="pa-0 pt-5" v-else>
        <v-layout wrap>
          <v-flex v-for="channel in channels" :key="channel.id" xs12 sm6 lg3 class="mb-5">
            <channel-card :channel="channel"></channel-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/Dashboard';
import userAPI from '@/api/user.js';
import ChannelCard from '@/components/global/ChannelCard';
export default {
  name: 'Channels',
  components: {
    LayoutBasic,
    ChannelCard,
  },
  data() {
    return {
      channels: [],
      loading: false,
      params: '?limit=999999',
    };
  },
  mounted() {
    this.getChannels();
  },
  computed: {
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  methods: {
    getChannels() {
      this.loading = true;
      userAPI.getChannels(this.params).then((response) => {
        this.loading = false;
        this.channels = response.data.data;
      });
    },
  },
};
</script>
